/**
 * Hook: useFetchComparisonScoringConfig
 *
 * ADD this file to: datatool_fe-QA/src/hooks/useFetchComparisonScoringConfig.tsx
 */
import { useEffect, useState } from "react";
import { IComparisonScoringConfig } from "../types/Scoring.type";
import { getComparisonScoringConfigByRule } from "../services/scoringService";

interface IuseFetchComparisonScoringConfig {
  setIsLoading: any;
  ruleId: any;
}

const useFetchComparisonScoringConfig = ({
  setIsLoading,
  ruleId,
}: IuseFetchComparisonScoringConfig) => {
  const [comparisonScoringConfig, setComparisonScoringConfig] =
    useState<IComparisonScoringConfig | null>(null);

  useEffect(() => {
    if (ruleId && ruleId > 0) {
      setIsLoading(true);
      const fetchConfig = async () => {
        try {
          const result = await getComparisonScoringConfigByRule(ruleId);
          setComparisonScoringConfig(result);
        } catch (err) {
          setComparisonScoringConfig(null);
        } finally {
          setIsLoading(false);
        }
      };
      fetchConfig();
    }
  }, [ruleId]);

  return [comparisonScoringConfig];
};

export default useFetchComparisonScoringConfig;
